import React, { useEffect } from "react"
import { Grid } from "@mui/material";
import Slider from '@mui/material/Slider';
import { toast } from 'react-toastify';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import AutorenewIcon from "@mui/icons-material/Autorenew";

// Styles
import { ContainerStyles, ContainerOpt, Input, Text } from './styles';
import { generatePassword } from "../../../utils/commonFunctions";
import { ColorsContext } from "../../../Context/ColorsContext"
import { useTranslation } from 'react-i18next'
import { CustomIconButtonDemo } from "../../../pages/styles";

export const PasswordGenerator = ({ onGenerate, buttonRef }) => {
    const { t } = useTranslation();
    const { colors } = React.useContext(ColorsContext);

    const passRef = React.useRef(true)

    const [sliderValue, setSliderValue] = React.useState(16);
    const [fieldValue, setFieldValue] = React.useState(16);
    const [password, setPassword] = React.useState('');
    const [isBottom, setIsBottom] = React.useState(true);
    const [limitSlider, setLimitSlider] = React.useState({ min: 8, max: 32 })

    const handleSliderChange = (newValue) => {
        if (sliderValue !== newValue) {
            handleGeneratePassword(newValue)
        }
        setSliderValue(newValue);
        setFieldValue(newValue);
    };
  
    const handleGeneratePassword = React.useCallback((newValue = sliderValue) => {
        const generatedPassword = generatePassword(newValue);
        setPassword(generatedPassword)
    }, [sliderValue]);

    const handleCopyToClipboard = async () => {
        try {
          await navigator.clipboard.writeText(password);
          toast.success(t('common.passwordClipboard'))
        } catch (error) {
            console.error('Permission not granted!:', error);
        }
        onGenerate(password)
    };

    const handleInputChange = (evt) => {
        const newValue = evt.target.value === '' ? limitSlider.min : Number(evt.target.value);
        setFieldValue(newValue);
    };

    const handleBlur = (evt) => {
        let newValue = evt.target.value === '' ? limitSlider.min : Number(evt.target.value);
        if (newValue < limitSlider.min) {
            newValue = limitSlider.min
        } else if (newValue > limitSlider.max) {
            newValue = limitSlider.max
        }
        setSliderValue(newValue);
        setFieldValue(newValue);
        handleSliderChange(newValue)
    };

    useEffect(() => {
        if (passRef.current) {
            handleGeneratePassword()
            passRef.current = false
        }
    }, [handleGeneratePassword]);

    return (
        <ContainerStyles>
            <Grid container spacing={1}>
                <Grid item xs={8}>
                    <Slider
                        value={sliderValue}
                        onChange={(evt) => handleSliderChange(evt.target.value)}
                        valueLabelDisplay="auto"
                        min={limitSlider.min}
                        max={limitSlider.max}
                        sx={{
                            '& .MuiSlider-rail': {
                                color: colors.sidebarSelectColor,
                            },
                            '& .MuiSlider-track': {
                                backgroundColor: colors.sidebarSelectColor,
                                border: `1px solid ${colors.sidebarSelectColor}`
                            },
                            '& .MuiSlider-thumb': {
                                backgroundColor: colors.sidebarSelectColor, // Cambiar el color de la bolita del slider
                                '&:hover, &.Mui-focusVisible': {
                                  boxShadow: `0px 0px 0px 8px ${colors.sidebarSelectColor}33`, // Cambiar el color del borde al hacer hover o enfocar
                                },
                            },
                        }}
                    />
                </Grid>
                <Grid item xs={4}>
                    <Input
                        value={fieldValue}
                        onChange={(evt) => handleInputChange(evt)}
                        onBlur={(evt) => handleBlur(evt)}
                        inputProps={{
                            maxLength: 2,
                            step: 1,
                            min: limitSlider.min,
                            max: limitSlider.max,
                            type: 'number'
                        }}
                    />
                </Grid>
				
                <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column' }}>
					<Text>{t('common.passwordHint')}</Text>
					<Input
						value={password}
						inputProps={{
							readOnly: true,
							style: {
							cursor: 'pointer',
							},
						}}
					/>
				</Grid>
                <Grid item xs={2} mt='13px'>
					<CustomIconButtonDemo
						btnType="graySidebar"
						onClick={() => handleCopyToClipboard()}
						>
						<LibraryAddCheckIcon />
					</CustomIconButtonDemo>
				</Grid>
				<Grid item xs={2} mt='13px'>
					<CustomIconButtonDemo
						btnType="graySidebar"
						onClick={() => handleGeneratePassword(sliderValue)}
						>
						<AutorenewIcon />
					</CustomIconButtonDemo>
				</Grid>
            </Grid>
        </ContainerStyles>
    )
}